import yo from '../img/yo.jpg'

function ProfilePic() {
    return (
    <header>
      <img src={yo} className="pic"></img>
    </header>
    );
  }
  
  export default ProfilePic;